module.exports = __webpack_public_path__ + "static/media/screenshot-transfer.19950c48.png";